import React, { Component } from 'react';
import { any, array, arrayOf, bool, func, number, object, oneOfType, shape, string } from 'prop-types';
import RecentReportsDisplay from '../../../components/Home/RecentReports/RecentReports';
import { connect } from 'react-redux';
import { actions as recentReportsActions } from '../../../reducers/modules/recentReports/recentReports';
import { withRouter } from 'react-router';

const REPORT_LIBRARY_URL = '/reports/library';

class RecentReports extends Component {
  static propTypes = {
    dispatch: func,
    history: object,
    location: object,
    match: object,
    recentReports: shape({
      data: arrayOf(
        shape({
          id: oneOfType([string, number]),
          lastModified: any,
          lastModifiedBy: shape({ firstName: string, lastName: string }),
          name: string
        })
      ),
      favoriteReports: array,
      error: string,
      favoritesError: string,
      loading: bool,
      retries: number,
      favoritesRetries: number,
      selectedTabIndex: number
    })
  };

  constructor(props) {
    super(props);

    this.browseReportsClick = this.browseReportsClick.bind(this);
    this.fetchReports = this.fetchReports.bind(this);
    this.fetchFavorites = this.fetchFavorites.bind(this);
    this.reportClick = this.reportClick.bind(this);
    this.reportTypeTabClick = this.reportTypeTabClick.bind(this);
  }

  componentDidMount() {
    this.fetchReports();
    this.fetchFavorites();
  }

  browseReportsClick() {
    const { history } = this.props;

    history.push({ pathname: REPORT_LIBRARY_URL });
  }

  fetchReports() {
    const { dispatch } = this.props;

    recentReportsActions.getRecentReports(dispatch);
  }

  fetchFavorites() {
    const { dispatch } = this.props;

    recentReportsActions.getFavoriteReports(dispatch);
  }

  reportTypeTabClick(index) {
    const { dispatch } = this.props;

    recentReportsActions.switchReportTab(dispatch, index);
  }

  reportClick(reportId) {
    const { history } = this.props;
    const reportUrl = `/iframe/app/#reportWriter/${reportId}`;

    // MPE-2317: Adding state.history for back navigation
    history.push({
      pathname: reportUrl,
      state: {
        history: '/reports/library'
      }
    });
  }

  render() {
    const {
      data,
      error,
      loading,
      retries,
      favoriteReports,
      favoritesRetries,
      favoritesError,
      selectedTabIndex
    } = this.props.recentReports;

    return (
      <RecentReportsDisplay
        browseReportsClick={this.browseReportsClick}
        error={error}
        favoritesError={favoritesError}
        loading={loading}
        recentReports={data}
        favoriteReports={favoriteReports}
        reFetchReports={this.fetchReports}
        refetchFavorites={this.fetchFavorites}
        reportLinkClick={this.reportClick}
        retries={retries}
        favoritesRetries={favoritesRetries}
        selectedTabIndex={selectedTabIndex}
        reportTypeTabClick={this.reportTypeTabClick}
      />
    );
  }
}

const mapStateToProps = ({ recentReports }) => ({ recentReports });

export default connect(mapStateToProps)(withRouter(RecentReports));
